import { IDefaultRequestProps } from "types/general/GeneralStateModelInterfaces";
import { ICombinedRequestStatus, combineRequestStatusses } from "functions/CombineRequestStatusses";
import { useMemo } from "react";

/** Returns a combined result that represents wether the data has loaded */
function useCombinedRequestStatus(...dataStates: IDefaultRequestProps[]): ICombinedRequestStatus {
	const combinedRequestStatus: ICombinedRequestStatus = useMemo(
		() => combineRequestStatusses(...dataStates), [dataStates]
	);

	return combinedRequestStatus;
}

export default useCombinedRequestStatus;